import Content from '@layout/Content'
import BasementWallForm from './BasementWallForm'
import BasementWallResult from './BasementWallResult'
import { BasementWallProvider } from './context'

function BasementWallPage () {
  return (
    <BasementWallProvider>
      <Content
        renderInput={<BasementWallForm />}
        renderOutput={<BasementWallResult />}
      />
    </BasementWallProvider>
  )
}

export default BasementWallPage
